import {
    helpers,
} from 'faker';
import { Record } from 'react-admin';
import { Db } from './types';

const names = helpers.shuffle(['佐藤', '鈴木', '高橋', '田中', '伊藤']);

export const generateUsers = (db: Db): Record[] => {
    return Array.from(Array(names.length).keys()).map(i => {
        const createdAt = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000);
        return {
            id: i + 1,
            name: names[i],
            createdAt: createdAt,
            updatedAt: createdAt,
        };
    });
};
